module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-chunk-01@2x.33adf755.jpg";